import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import IdentityFormFields from './IdentityFormFields'
import useIdentity from './useIdentity'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'

const IdentityModal = () => {
  const { t, hidden, isFilled, isOpen, openModal, closeModal } = useIdentity()

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='1rem'>
      {/* @ts-ignore */}
      <SDOutlineButton
        onClick={openModal}
        endEnhancer={isFilled ? () => <IconCarbonCheckmarkOutline size={24} color='green' /> : undefined}
      >
        {t('subscriptionForm:identity_module.module_title')}
      </SDOutlineButton>
      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:identity_module.module_title')}
        sections={<IdentityFormFields />}
      />
    </SpacingWrapper>
  )
}

export default IdentityModal
